export * from './protected-resources';